import { render } from "./LiveWatch.vue?vue&type=template&id=a71636ec&scoped=true"
import script from "./LiveWatch.vue?vue&type=script&lang=js"
export * from "./LiveWatch.vue?vue&type=script&lang=js"

import "./LiveWatch.vue?vue&type=style&index=0&id=a71636ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71636ec"]])

export default __exports__